module.exports = __webpack_public_path__ + "static/media/Roboto-Medium.574fd0b5.woff2";


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/themes/src/fonts/roboto/Roboto-Medium.woff2
// module id = 1465
// module chunks = 0